import { Injectable } from '@angular/core';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { TransferRequestItem } from '../models/transferRequestItem.model';
import { Observable, of } from 'rxjs';
import { List } from '../../core/models/list';
import { TransferRequestApiService } from './transfer-request-api.service';
import { ConfirmService } from '../../utils/confirm/confirm.service';
import { ToastrService } from 'ngx-toastr';
import { Filters } from '../../core/services/list/models/Filters';
import { TextFilterField } from '../../core/services/list/models/TextFilterField';
import { Conditions } from '../../core/services/list/models/FilterField';
import { Order } from '../../core/services/list/models/Order';
import { SortDirection } from '../../core/services/list/models/sort-direction.enum';
import { Paginator } from '../../core/services/list/models/Paginator';
import { FiltersService } from '../../utils/filters/services/filters.service';

@Injectable({
  providedIn: 'root',
})
export class TransferRequestService {
  constructor(
    private transferRequestApiService: TransferRequestApiService,
    private confirmService: ConfirmService,
    private toastr: ToastrService,
    private filtersService: FiltersService,
  ) {}

  toTake: TransferRequestItem[] = null;

  toPut: TransferRequestItem[] = null;

  getToTake(): Observable<List<TransferRequestItem>> {
    return this.transferRequestApiService.getToTake().pipe(tap(({ items }) => (this.toTake = items)));
  }

  getToPut(): Observable<List<TransferRequestItem>> {
    return this.transferRequestApiService.getToPut().pipe(tap(({ items }) => (this.toPut = items)));
  }

  cancelReservation(id: number): Observable<any> {
    return this.confirmService.show('Do you want cancel this reserve?').pipe(
      filter(confirm => confirm),
      switchMap(() => this.transferRequestApiService.cancelReserved({ ids: [id] })),
      tap(() => {
        this.toastr.success('Reserved has been canceled');
      }),
      switchMap(() => this.getToPut()),
      switchMap(() => this.getToTake()),
    );
  }

  reserve(sourceLocationId: number, productSeriesId: number, id: number): Observable<void> {
    return this.transferRequestApiService
      .getUnassigned(
        new Filters(
          [
            new TextFilterField('sourceLocation.id', 'sourceLocation.id')
              .setCondition(Conditions.EQ)
              .patchValue(sourceLocationId),
          ],
          new Order(['sourceLocation.id', SortDirection.ASC], []),
          new Paginator(1, 9999999),
        ),
      )
      .pipe(
        switchMap(() =>
          this.confirmService.show('Do you want to reserve this request?').pipe(
            filter(decision => decision === true),
            switchMap(() => this.transferRequestApiService.reserve({ ids: [id] })),
            tap(() => {
              this.toastr.success('Request has been reserved');
              this.filtersService.emitRefreshSubject();
            }),
            catchError(err => of(err)),
          ),
        ),
        catchError(err => of(err)),
      );
  }

  removeTransferRequest(id: number): Observable<void> {
    return this.confirmService.show('Do you want to remove this request?').pipe(
      filter(decision => decision === true),
      switchMap(() => this.transferRequestApiService.deleteTransferRequest(id)),
      tap(() => {
        this.toastr.success('Request has been deleted');
        this.filtersService.emitRefreshSubject();
      }),
      catchError(err => of(err)),
    );
  }
}
